export default __webpack_public_path__ + "static/media/pokemon_dark.e719b2db.png";